import React from "react";
import { useNavigate } from "react-router-dom";
import reloadOnceForChunkError from "../../Utils/chunkReloadGuard";
import { BUILD_ID } from "../../Utils/buildInfo";

class RouteErrorBoundaryImpl extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      attemptedReload: false,
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    const attemptedReload = reloadOnceForChunkError(error);
    if (attemptedReload) {
      this.setState({ attemptedReload: true });
    }
    if (this.props.onError) {
      this.props.onError(error, errorInfo);
    }
  }

  handleReload = () => {
    window.location.reload();
  };

  handleGoHome = () => {
    if (typeof this.props.navigate === "function") {
      this.props.navigate("/dashboard");
    }
  };

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    if (this.state.attemptedReload) {
      return (
        <div style={{ padding: "32px", textAlign: "center" }}>
          <h2>Updating...</h2>
          <p>We are loading the latest version.</p>
          <p style={{ opacity: 0.7 }}>Build: {BUILD_ID}</p>
        </div>
      );
    }

    const errorMessage =
      this.state.error?.message || this.state.error?.toString?.() || "";

    return (
      <div style={{ padding: "32px", textAlign: "center" }}>
        <h2>Something went wrong</h2>
        <p>Please try reloading the app.</p>
        <p style={{ opacity: 0.7 }}>Build: {BUILD_ID}</p>
        <div style={{ marginTop: "16px" }}>
          <button onClick={this.handleReload} type="button">
            Reload App
          </button>
          {typeof this.props.navigate === "function" && (
            <button
              onClick={this.handleGoHome}
              type="button"
              style={{ marginLeft: "12px" }}
            >
              Go to Dashboard
            </button>
          )}
        </div>
        {errorMessage && (
          <details style={{ marginTop: "16px", textAlign: "left" }}>
            <summary>Error details</summary>
            <pre style={{ whiteSpace: "pre-wrap" }}>{errorMessage}</pre>
          </details>
        )}
      </div>
    );
  }
}

const RouteErrorBoundary = ({ children }) => {
  const navigate = useNavigate();
  return (
    <RouteErrorBoundaryImpl navigate={navigate}>
      {children}
    </RouteErrorBoundaryImpl>
  );
};

export default RouteErrorBoundary;
